export default "__VITE_ASSET__DfDQlrsr__"